/**
 * Replaces BpmnUpdater with SafeBpmnUpdater to fix flowElements push error.
 */
import SafeBpmnUpdater from './SafeBpmnUpdater';

const safeBpmnUpdaterModule = {
  bpmnUpdater: ['type', SafeBpmnUpdater]
};
export default safeBpmnUpdaterModule;
